// @ts-ignore – react-countup ships a CJS default export
import CountUpLib from 'react-countup'
const CountUp = (CountUpLib as unknown as { default: typeof CountUpLib }).default ?? CountUpLib
import { useCampaign } from '../../context/CampaignContext'

const StatsBar = () => {
  const { stats, isLoading } = useCampaign()
  const { total_raised } = stats

  const parsedRaised = Number(String(total_raised).replace(/[^0-9.-]/g, '')) || 0

  return (
    <div className="flex flex-col items-center" dir="ltr">
      {/* Large red amount with ILS sign */}
      <div className="flex items-baseline gap-2">
        <span
          className="text-4xl sm:text-5xl font-light text-[#e62e2e]"
          style={{ fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }}
        >
          ₪
        </span>
        <span
          className="text-4xl sm:text-5xl font-light text-[#e62e2e] tracking-tight"
          style={{ fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }}
        >
          {isLoading ? (
            <span className="opacity-30">0</span>
          ) : (
            <CountUp end={parsedRaised} duration={1.5} separator="," preserveValue />
          )}
        </span>
      </div>
    </div>
  )
}

export default StatsBar
